import NavigationError from "@/errors/navigation-error";
import { useBllsBalanceQuery } from "@/hooks/use-blls-balance-query";
import {
  useBllsTransactionsQuery,
  UseBllsTransactionsResponse,
} from "@/hooks/use-blls-transactions-query";
import useMeQuery from "@/hooks/use-me-query";
import usePermissions from "@/hooks/use-permissions";
import { FC, ReactNode } from "react";
import { Outlet } from "react-router";

const WelcomeGuard: FC<{ children?: ReactNode }> = ({ children }) => {
  const { data } = useMeQuery();
  const { data: balance } = useBllsBalanceQuery({
    fetchParams: {
      path: {
        address: data!.address!,
      },
    },
  });

  const { data: transactions } = useBllsTransactionsQuery({
    fetchParams: {
      query: {
        limit: 1,
        address: data!.address!,
      },
    },
    queryOptions: {
      errorResult: [] as UseBllsTransactionsResponse,
    },
  });
  const { can } = usePermissions();
  if (can("skip-subscription")) {
    return children ?? <Outlet />;
  }

  if (!balance[import.meta.env.VITE_CURRENCY_SYMBOL] && !transactions.length) {
    throw new NavigationError("/welcome");
  }
  return children ?? <Outlet />;
};

export default WelcomeGuard;
